import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import resguardosApi from 'api/resguardos';
import { hotelMap } from 'views/admin/salidas/types';

export interface ColaboradorDeBaja {
  ResguardoId: number;
  usuarioNumColab: string;
  Usuario: string;
  usuarioDueno: string;
  Departamento: string;
  HotelActivo: string[];
  HotelNomina: string[];
  colaboradorDeOtraPropiedad: boolean;
  NombreNomina: string;
  EstatusNomina: string;
  resguardoStatus: string;
  resguardoCreatedDate: string;
}

interface ResguardosBajaContextValue {
  colaboradoresDeBaja: ColaboradorDeBaja[];
  total: number;
  fetchResguardosBaja: () => Promise<void>;
}

const ResguardosBajaContext = createContext<ResguardosBajaContextValue | undefined>(undefined);

const getHotelId = (): number | null => {
  const hotelSeleccionado = sessionStorage.getItem('hotelSeleccionado');
  if (!hotelSeleccionado) return null;
  return hotelMap[hotelSeleccionado] || null;
};

export const ResguardosBajaProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [colaboradoresDeBaja, setColaboradoresDeBaja] = useState<ColaboradorDeBaja[]>([]);

  const fetchResguardosBaja = useCallback(async () => {
    const hotelId = getHotelId();
    if (!hotelId) return;
    const data = await resguardosApi.verificarBajas(hotelId);
    if (data) {
      setColaboradoresDeBaja(Array.isArray(data.colaboradoresDeBaja) ? data.colaboradoresDeBaja : []);
    }
  }, []);

  useEffect(() => {
    fetchResguardosBaja();
    const interval = setInterval(fetchResguardosBaja, 60_000);
    const onHotelChange = () => fetchResguardosBaja();
    window.addEventListener('hotelCambiado', onHotelChange);
    return () => {
      clearInterval(interval);
      window.removeEventListener('hotelCambiado', onHotelChange);
    };
  }, [fetchResguardosBaja]);

  const total = colaboradoresDeBaja.length;

  return (
    <ResguardosBajaContext.Provider value={{ colaboradoresDeBaja, total, fetchResguardosBaja }}>
      {children}
    </ResguardosBajaContext.Provider>
  );
};

export const useResguardosBaja = (): ResguardosBajaContextValue => {
  const ctx = useContext(ResguardosBajaContext);
  if (!ctx) throw new Error('useResguardosBaja must be used within ResguardosBajaProvider');
  return ctx;
};
